import styled from 'styled-components'
import { customTheme } from '../../styles/theme'

interface IContainerProps {
  justify?: 'flex-start' | 'center'
}

export const Container = styled.div<IContainerProps>`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: ${({ justify }) => justify || 'flex-start'};
  justify-content: flex-start;

  iframe {
    max-width: 100%;
    height: unset;
    aspect-ratio: 16/9;
  }
`

export const Instructions = styled.div`
  width: 100%;
  margin-bottom: 15px;
  word-wrap: break-word;
`

export const CentralizedInstructions = styled.div`
  width: 100%;
  max-width: 90%;
`

export const Image = styled.img`
  width: 80px;
  height: 80px;
  margin: 0 auto;
  margin-bottom: 2%;

  border-radius: 50%;
`

export const ActionButtons = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  margin: 20px 0;

  button {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 35%;
    height: 130px;
    justify-content: center;
    border: solid 3px #000;
    cursor: pointer;
    border-radius: 15px;

    @media (max-width: ${customTheme.breakpoints[2]}) {
      width: 45%;
    }

    svg {
      font-size: 50px;
    }
  }
`

export const DragDropButton = styled.div`
  display: flex;
  height: 50px;
  border: solid 3px #000;
  border-radius: 15px;
  background-color: #f0f0f0;
  width: 100%;
  justify-content: center;
  padding: 10px 0;
  align-items: center;

  svg {
    font-size: 20px;
  }
`
export const GroupButtons = styled.div`
  display: flex;
  border-radius: 15px;
  width: 100%;
  justify-content: center;
  padding: 10px 0;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    width: 35%;
    justify-content: center;
    border: solid 3px #000;
    cursor: pointer;
    border-radius: 15px;
    padding: 10px 0;

    @media (max-width: ${customTheme.breakpoints[2]}) {
      width: 45%;
    }

    svg {
      font-size: 20px;
    }
  }

  h4 {
    margin: 0 5px;
  }
`
